import { Typography, Paper, Box, Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Box sx={{ my: 2 }}>
        <Typography variant="body1" gutterBottom>
          The page you are looking for does not exist.
        </Typography>
        <Button variant="contained" component={RouterLink} to="/" sx={{ mt: 2 }}>
          Go back to home page
        </Button>
      </Box>
    </Paper>
  );
};

export default NotFound;
